import React, { Component } from 'react';
import { getDollarFormat } from 'utils/helpers';
import { mapDashboardPO } from 'utils/mappers';
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';
import { connect } from 'react-redux';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
// import LinearProgress from '@mui/material/LinearProgress';
import LinearProgress from '@mui/material/LinearProgress';
import { getPurchaseOrdersDb } from 'actions/DashboardActions';

class PurchaseOrders extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const purchaseOrder = this.props.purchaseOrder;
        return (
            <div id="chart8" className="item col-4-p-0 ml-3">
                <DashDialog 
                    text="Purchase Orders"
                    link="/purchaseorder"
                    isReport={true}
                    refreshAction={() => this.props.getPurchaseOrdersDb(this.props.branchId)} />
                {
                    this.props.loading
                        ?
                        <LinearProgress variant="indeterminate" />
                        :
                        <div className="po_height">
                            <div className="row pt-4 m-0">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <label className="db-label mt-0 mb-0">This Week</label>
                                    <h2 className="light-weight size-4em mt-0 mb-0">{purchaseOrder.weeklyData.numberOfPurchaseOrders}</h2>
                                    <h4 className="green-text mt-0 mb-0">{getDollarFormat(purchaseOrder.weeklyData.amountOfPurchaseOrders)}</h4>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <label className="db-label mt-0 mb-0">This Month</label>
                                    <h2 className="light-weight size-4em mt-0 mb-0">{purchaseOrder.monthlyData.numberOfPurchaseOrders}</h2>
                                    <h4 className="green-text mt-0 mb-0">{getDollarFormat(purchaseOrder.monthlyData.amountOfPurchaseOrders)}</h4>
                                </div>
                            </div>
                            <h3 className="">Latest Open Purchase Orders: {purchaseOrder.numberOfOpenPurchaseOrders}</h3>
                            {purchaseOrder.numberOfOpenPurchaseOrders !== 0 ?
                                <div className="">
                                    {<GenericTable
                                        className="table_center tableHeaderwhiteColorFont"
                                        tableBodyClassName=""
                                        multiSelectable={false}
                                        enableSelectAll={false}
                                        selectable={false}
                                        stripedRows={true}
                                        columns={LOOKUP.purchaseOrder.dashBoardTable}
                                        rows={mapDashboardPO(purchaseOrder.purchaseOrders)}
                                    />}
                                </div>
                                : null
                            }

                        </div>
                }

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.common.dbPoCall > 0,
        branchId: state.common.branchId
    }
}

function mapDispatchToProps(dispatch){
    return {
        getPurchaseOrdersDb: (branchId) => dispatch(getPurchaseOrdersDb(branchId, true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrders);